import axios from 'axios';
var API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT;
var SWIFT_API_ENDPOINT = process.env.VUE_APP_SWIFT_API_ENDPOINT;
var GSAI_ENDPOINT = process.env.VUE_APP_GSAI_ENDPOINT;
//var API_ENDPOINT = "https://localhost:44346/";

// Authorization header, omitted entirely when there is no token. The Lock Extension landing page
// is reachable anonymously from the emailed link (see LockExtensionLanding.vue), and sending
// "Bearer undefined" there risks the auth handlers rejecting a request the endpoint allows.
function authHeaders(token) {
  return token ? { "Authorization": "Bearer " + token } : {};
}

// ── Request-level cache for expensive, frequently-duplicated calls ──
// Prevents the same GET from being in-flight more than once at a time,
// and caches the result for `ttl` ms so rapid successive calls are free.
const _cache = {};
function cachedGet(cacheKey, url, token, ttl = 30000) {
  const now = Date.now();
  const entry = _cache[cacheKey];

  // Return cached result if still fresh
  if (entry && entry.resolved && (now - entry.ts) < ttl) {
    return Promise.resolve(entry.value);
  }

  // Return in-flight promise if one exists
  if (entry && entry.promise) {
    return entry.promise;
  }

  // Otherwise fire the request and cache it
  const promise = axios.get(url, {
    headers: { "Authorization": "Bearer " + token }
  }).then(res => {
    _cache[cacheKey] = { resolved: true, value: res, ts: Date.now(), promise: null };
    return res;
  }).catch(err => {
    delete _cache[cacheKey]; // allow retry on failure
    throw err;
  });

  _cache[cacheKey] = { resolved: false, promise };
  return promise;
}

// Call this when the active user changes (impersonation switch, logout)
// so stale data is never served.
function clearApiCache() {
  Object.keys(_cache).forEach(k => delete _cache[k]);
}

export default {
  clearApiCache,
  async GetImpersonableUsers(azureId, token) {
    return axios.get(API_ENDPOINT + `api/CGSTask/GetUsersSelectsActiveOnly?azureId=${azureId}`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    );
  },
  FetchData(LPID, token) {
    return axios.get(API_ENDPOINT + `api/Contacts/GetContactsByLPID?LPID=${LPID}`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    );
  },
  async GetExt1(azureId, token) {
    return axios.get(API_ENDPOINT + `api/Contacts/GetExtensionAttribute1ByUserId?Id=${azureId}`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    );
  },
  async GetExt4(azureId, token) {
    return axios.get(API_ENDPOINT + `api/Contacts/GetExtensionAttribute4ByUserId?Id=${azureId}`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    );
  },
  async GetRoles(azureId, token) {
    return cachedGet(`roles:${azureId}`, API_ENDPOINT + `api/Roles/GetUserRoles?Id=${azureId}`, token);
  },
  async GetAll(azureId, token) {
    return axios.get(API_ENDPOINT + `api/Contacts/GetAllActiveOrOriginated?Id=${azureId}`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    );
  },
  async GetAllByORGID(ORGID, token) {
    return axios.get(API_ENDPOINT + `api/Contacts/GetAllActiveOrOriginatedByORGID?Id=${ORGID}`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    );
  },
  async GetSwiftAppPipelineNonActive(azureId, token) {
    return axios.get(API_ENDPOINT + `api/Contacts/GetSwiftAppPipelineNonActive?azureId=${azureId}`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }

      }
    );
  },
  async GetSwiftAppPipeline(azureId, token) {
    return axios.get(API_ENDPOINT + `api/Contacts/GetSwiftAppPipeline?azureId=${azureId}`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }

      }
    );
  },
  async GetSwiftAppPipelineV2(azureId, odata, token) {
    return axios.get(API_ENDPOINT + `api/Contacts/GetSwiftAppPipelineV2?azureId=${azureId}&odata=${odata}`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }

      }
    );
  },
  async GetSwiftDashboardData(azureId, newDash, all, token) {
    return axios.get(
      API_ENDPOINT + `api/SwiftAppAI/GetSwiftDashboardData?azureId=${azureId}&newDash=${newDash}&all=${all}`,
      {
        headers: {
          Authorization: "Bearer " + token
        }
      }
    );
  },
  async GetSwiftDashboardNewApplications(azureId, token) {
    return axios.get(API_ENDPOINT + `api/SwiftAppAI/GetSwiftDashboardNewApplications?azureId=${azureId}`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }

      }
    );
  },
  async GetDailyFeed(azureId, token) {
    //console.log("api service azureId = " + azureId);
    return axios.get(API_ENDPOINT + `api/SwiftAppAI/GetDailyFeed?azureId=${azureId}`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }

      }
    );
  },
  async GetExpiringLocks(azureId, token) {
    //console.log("api service azureId = " + azureId);
    return axios.get(API_ENDPOINT + `api/SwiftAppAI/GetExpiringLocks?azureId=${azureId}`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }

      }
    );
  },
  async GetInternalTasks(azureId, token) {
    return axios.get(API_ENDPOINT + `api/SwiftAppAI/GetInternalTasks?azureId=${azureId}`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }

      }
    );
  },
  async GetInternalTasksByOrgId(azureId, token) {
    return axios.get(API_ENDPOINT + `api/SwiftAppAI/GetBranchInternalTasks?azureId=${azureId}`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }

      }
    );
  },
  async GetTasksGrouped(token) {
    return axios.get(API_ENDPOINT + `api/CGSTask/GetTasksCountGrouped`,
      {
        headers: {
          "Authorization": "Bearer" + token
        }
      }
    );
  },
  async GetUsersByOrgIdByRole(azureId, token) {
    return axios.get(API_ENDPOINT + `api/ContactTeams/GetUsersByOrgIdByRole?azure_id=${azureId}`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    );
  },
  async GetUsers(token) {
    return axios.get(API_ENDPOINT + 'api/ContactTeams/GetUsers',
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    )
  },
  async GetNotificationTemplates(token) {
    return axios.get(API_ENDPOINT + 'api/EmailManager/GetNotificationTemplates',
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    )
  },
  async UpsertNotificationCCSettings(request, token, update = 'false') {
    return axios.post(API_ENDPOINT + `api/NotificationCCSettings/UpsertNotificationCCSettings?update=${update}`, request,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    )
  },
  async GetUsersNotificationCCSettings(email, type, token) {
    return axios.get(API_ENDPOINT + `api/NotificationCCSettings/GetUsersNotificationCCSettings?userEmail=${email}&type=${type}`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    )
  },
  async DeleteNotificationCCSettings(request, token) {
    return axios.post(API_ENDPOINT + 'api/NotificationCCSettings/DeleteNotificationCCSettings', request,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    )
  },
  async GetLODisclosuresCount(azureId, token) {
    return axios.get(API_ENDPOINT + `api/SwiftAppAI/GetLODisclosuresCount?azureId=${azureId}`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    );

  },
  async GetUnlockedLoans(azureId, token) {
    //console.log("api service azureId = " + azureId);
    return axios.get(API_ENDPOINT + `api/SwiftAppAI/GetUnlockedLoans?azureId=${azureId}`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }

      }
    );
  },
  async GetPostCloseSummarys(token) {
    //console.log("api service azureId = " + azureId);
    //return await axios.get('https://localhost:44346/' + `api/SwiftAppAI/GetPostCloseSummarys`,
    return await axios.get(API_ENDPOINT + `api/SwiftAppAI/GetPostCloseSummarys`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }

      }
    );
  },
  async GetPostCloseSummarysV2(token) {
    return await axios.get(API_ENDPOINT + `api/PostCloseConnectV2/GetPostCloseSummarysV2`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }

      }
    );
  },

  async CreateManualBorrowerTaskNotifications(loanId, token) {
    console.log(token);
    return axios.post(API_ENDPOINT + `api/LoanLaunchNotifications/CreateManualBorrowerTaskNotificationsDashboard?loanId=${loanId}`, {},
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  async GetUsersNotificationSubscriptionSettings(azureId, token) {
    return axios.get(API_ENDPOINT + `api/EmailMessaging/GetUsersNotificationSubscriptionSettings?azureId=${azureId}`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }

      });
  },
  async DeleteNotificationOptOuts(request, token) {
    return axios.post(API_ENDPOINT + `api/NotificationOptOut/NotificationOptOutsDelete`, request,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  async UpsertNotificationOptOuts(request, token) {
    return axios.post(API_ENDPOINT + `api/NotificationOptOut/NotificationOptOutsUpsert`, request,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  async GetLoanDisplayData(loanNumber, token) {
    return axios.get(API_ENDPOINT + `api/Loans/GetLoanDisplayData?loanNumber=${loanNumber}`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }

      });
  },
  async GetUsersSMSPushSubscriptionSettings(azureId, token) {
    return axios.get(API_ENDPOINT + `api/NotificationOptOut/GetUsersSMSPushSubscriptionSettings?azureId=${azureId}`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }

      });
  },
  async DeletePushOptIns(request, token) {
    return axios.post(API_ENDPOINT + `api/NotificationOptOut/PushOptInsDelete`, request,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  async UpsertPushOptIns(request, token) {
    return axios.post(API_ENDPOINT + `api/NotificationOptOut/PushOptInsUpsert`, request,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  async DeleteSMSOptIns(request, token) {
    return axios.post(API_ENDPOINT + `api/NotificationOptOut/SMSOptInsDelete`, request,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  async UpsertSMSOptIns(request, token) {
    return axios.post(API_ENDPOINT + `api/NotificationOptOut/SMSOptInsUpsert`, request,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  async GetGrouping(azureId, token) {
    return axios.get(API_ENDPOINT + `api/UserSettings/GetGrouping?azureId=${azureId}`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  async GetUsersAzureData(azureId, token) {
    return cachedGet(`azuredata:${azureId}`, API_ENDPOINT + `api/UserSettings/GetUsersAzureData?id=${azureId}`, token);
  },
  async GetGroupingInternalTasks(azureId, token) {
    return axios.get(API_ENDPOINT + `api/SwiftAppAI/GetGroupingInternalTasks?azureId=${azureId}`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  async GetTasksIAssigned(azureId, token) {
    return axios.get(API_ENDPOINT + `api/SwiftAppAI/GetTasksIAssigned?azureId=${azureId}`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  async GetUsersExternalSubscriptionSettings(azureId, token) {
    return axios.get(API_ENDPOINT + `api/EmailMessaging/GetUsersExternalSubscriptionSettings?azureId=${azureId}`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }

      });
  },
  async DeleteExternalNotificationOptOuts(request, token) {
    return axios.post(API_ENDPOINT + `api/NotificationOptOut/ExternalNotificationOptOutsDelete`, request,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  async UpsertExternalNotificationOptOuts(request, token) {
    return axios.post(API_ENDPOINT + `api/NotificationOptOut/ExternalNotificationOptOutsUpsert`, request,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  async GetUncompletedAppsByLOID(azureId, token) {
    return axios.get(API_ENDPOINT + `api/SwiftAppAI/GetUncompletedAppsByLOID?azureId=${azureId}`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }

      });
  },
  async GetUncompletedAppsByBranchGroup(azureId, token) {
    return axios.get(API_ENDPOINT + `api/SwiftAppAI/GetUncompletedAppsByBranchGroup?azureId=${azureId}`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }

      });
  },
  async GetLoanLaunchMessagesWithReadStatus(getLoanlaunchMessagesReq, token) {
    return axios.post(API_ENDPOINT + `api/LoanLaunchMessages/GetMessages`, getLoanlaunchMessagesReq,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  async GetUnreadLoanLaunchMessages(getLoanLaunchMessagesReq, token) {
    return axios.post(API_ENDPOINT + `api/LoanLaunchMessages/GetUnreadMessages`, getLoanLaunchMessagesReq,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  async MarkAllLoanLaunchMessagesRead(azureId, token) {
    return axios.post(API_ENDPOINT + `api/LoanLaunchMessages/MarkAllMessagesRead?azureId=${azureId}`, null,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      });
  },
  async UpsertInternalAssignedTask(params, token) {
    const body = {
      id: params.id,
      archived: params.archived,
      completed: params.completed,
      status: params.status,
      lastUpdated: params.lastUpdated,
      title: params.title,
      assignedTo: params.assignedTo,
      notes: params.notes,
      followUpDate: params.followUpDate,
      azureId: params.azureId,
      noteEmailSent: params.noteEmailSent,
      followUpSent: params.followUpSent
    };

    if (params.important !== undefined) {
      body.important = typeof params.important === 'boolean' ? (params.important ? "1" : "0") : (params.important || "0").toString();
    }

    if (params.initialEmailSent !== undefined) {
      body.initialEmailSent = typeof params.initialEmailSent === 'boolean' ? (params.initialEmailSent ? "1" : "0") : (params.initialEmailSent || "0").toString();
    }

    return axios.post(`${SWIFT_API_ENDPOINT}api/InternalTasks/UpsertInternalAssignedTask`, body, {
      headers: {
        "Authorization": "Bearer " + token,
        "Content-Type": "application/json"
      }
    });
  },
  async GetIncompleteApplicationsByAzureId(request, azureId, token) {
    return axios.post(SWIFT_API_ENDPOINT + `api/Applications/GetIncompleteApplicationsByAzureId?azureId=${azureId}`, request,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    )
  },
  async GetRecentlySubmittedApplicationsByAzureId(request, azureId, daysBack, token) {
    return axios.post(SWIFT_API_ENDPOINT + `api/Applications/GetRecentlySubmittedApplicationsByAzureId?azureId=${azureId}&daysBack=${daysBack}`, request,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    )
  },
  async GetApplicationsByAzureIdAndStartedDate(request, azureId, daysBack, token) {
    return axios.post(SWIFT_API_ENDPOINT + `api/Applications/GetApplicationsByAzureIdAndStartedDate?azureId=${azureId}&daysBack=${daysBack}`, request,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    )
  },
  async GetActiveApplicationAlertsByAzureId(request, azureId, token) {
    return axios.post(SWIFT_API_ENDPOINT + `api/Applications/GetActiveApplicationAlertsByAzureId?azureId=${azureId}`, request,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    )
  },
  async ClearApplicationAlert(request, token) {
    return axios.post(SWIFT_API_ENDPOINT + `api/Applications/ClearApplicationAlert`, request,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    )
  },
  async ArchiveApplicationById(request, token) {
    return axios.post(SWIFT_API_ENDPOINT + `api/Applications/ArchiveApplicationById`, request,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    )
  },
  async RestoreApplicationById(request, token) {
    return axios.post(SWIFT_API_ENDPOINT + `api/Applications/RestoreApplicationById`, request,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    )
  },
  async GetSwiftAppPipelineQueryResponse(azureId, token) {
    return axios.get(API_ENDPOINT + `api/Contacts/GetSwiftAppPipelineQueryResponse?azureId=${azureId}`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    )
  },
  async GetConditionsNeedingAttention(azureId, token) {
    return axios.get(
      SWIFT_API_ENDPOINT +
      `api/Conditions/GetConditionsNeedingAttention?azureId=${azureId}`,
      {
        headers: {
          Authorization: "Bearer " + token
        }
      }
    )
  },
  GetUserProfileImage(azureId, token) {
    return axios.get(
      `${API_ENDPOINT}api/GraphAPI/GetProfilePhoto?azureId=${encodeURIComponent(azureId)}`,
      { headers: { Authorization: "Bearer " + token } }
    )
  },
  async GetInternalTaskTeams(token) {
    return axios.get(API_ENDPOINT + `api/InternalTask/GetInternalTaskTeams`, {
      headers: {
        "Authorization": "Bearer " + token,
        "Content-Type": "application/json"
      }
    });
  },
  async GetTeamTasks(azureId, token) {
    return axios.get(API_ENDPOINT + `api/SwiftAppAI/GetTeamTasks?azureId=${azureId}`, {
      headers: {
        "Authorization": "Bearer " + token
      }
    });
  },
  GetUnderwrittenConditionStatsByUnderwriter(azureId, startDate, endDate, token, orgId = null) {
    const params = [
      `azureId=${encodeURIComponent(azureId)}`,
      `startDate=${encodeURIComponent(new Date(startDate).toISOString())}`,
      `endDate=${encodeURIComponent(new Date(endDate).toISOString())}`
    ]

    if (orgId !== null && orgId !== undefined) {
      params.push(`orgId=${encodeURIComponent(orgId)}`)
    }

    return axios.get(
      `${SWIFT_API_ENDPOINT}api/Conditions/GetUnderwrittenConditionStatsByUnderwriter?${params.join("&")}`,
      { headers: { Authorization: "Bearer " + token } }
    )
  },

  GetUnderwrittenLoanStatsByUnderwriter(azureId, startDate, endDate, token, orgId = null) {
    const params = [
      `azureId=${encodeURIComponent(azureId)}`,
      `startDate=${encodeURIComponent(new Date(startDate).toISOString())}`,
      `endDate=${encodeURIComponent(new Date(endDate).toISOString())}`
    ]

    if (orgId !== null && orgId !== undefined) {
      params.push(`orgId=${encodeURIComponent(orgId)}`)
    }

    return axios.get(
      `${SWIFT_API_ENDPOINT}api/Conditions/GetUnderwrittenLoanStatsByUnderwriter?${params.join("&")}`,
      { headers: { Authorization: "Bearer " + token } }
    )
  },
  GetRecentLoanNotes(azureId, token, orgId = null, top = 50) {
    const params = [`azureId=${encodeURIComponent(azureId)}`]

    if (orgId !== null && orgId !== undefined) {
      params.push(`orgId=${encodeURIComponent(orgId)}`)
    }

    if (top !== null && top !== undefined) {
      params.push(`top=${encodeURIComponent(top)}`)
    }

    return axios.get(
      `${SWIFT_API_ENDPOINT}api/Conditions/GetRecentLoanNotes?${params.join("&")}`,
      { headers: { Authorization: "Bearer " + token } }
    )
  },
  GetRecentLoans(azureId, token, top = 10) {
    const params = [`azureId=${encodeURIComponent(azureId)}`]

    if (top !== null && top !== undefined) {
      params.push(`top=${encodeURIComponent(top)}`)
    }

    return axios.get(
      `${SWIFT_API_ENDPOINT}api/Conditions/GetRecentLoans?${params.join("&")}`,
      { headers: { Authorization: "Bearer " + token } }
    )
  },

  GetSwiftMilestoneCounts(azureId, token, orgId = null, mineOnly = false) {
    const params = [`azureId=${encodeURIComponent(azureId)}`]

    if (orgId !== null && orgId !== undefined) {
      params.push(`orgId=${encodeURIComponent(orgId)}`)
    }

    if (mineOnly !== null && mineOnly !== undefined) {
      params.push(`mineOnly=${encodeURIComponent(mineOnly)}`)
    }

    return axios.get(
      `${API_ENDPOINT}api/SwiftAppAI/GetSwiftMilestoneCounts?${params.join("&")}`,
      { headers: { Authorization: "Bearer " + token } }
    )
  },

  GetSwiftMilestoneLoans(azureId, milestone, token, orgId = null, top = 200, mineOnly = false) {
    const params = [
      `azureId=${encodeURIComponent(azureId)}`,
      `milestone=${encodeURIComponent(milestone)}`
    ]

    if (orgId !== null && orgId !== undefined) {
      params.push(`orgId=${encodeURIComponent(orgId)}`)
    }

    if (top !== null && top !== undefined) {
      params.push(`top=${encodeURIComponent(top)}`)
    }

    if (mineOnly !== null && mineOnly !== undefined) {
      params.push(`mineOnly=${encodeURIComponent(mineOnly)}`)
    }

    return axios.get(
      `${API_ENDPOINT}api/SwiftAppAI/GetSwiftMilestoneLoans?${params.join("&")}`,
      { headers: { Authorization: "Bearer " + token } }
    )
  },

  GetSwiftClosingNext7Days(
    azureId,
    token,
    orgId = null,
    startDate = null,
    endDate = null,
    mineOnly = false
  ) {
    const params = [`azureId=${encodeURIComponent(azureId)}`]

    if (orgId !== null && orgId !== undefined) {
      params.push(`orgId=${encodeURIComponent(orgId)}`)
    }

    if (startDate !== null && startDate !== undefined) {
      params.push(`startDate=${encodeURIComponent(startDate)}`)
    }

    if (endDate !== null && endDate !== undefined) {
      params.push(`endDate=${encodeURIComponent(endDate)}`)
    }

    if (mineOnly !== null && mineOnly !== undefined) {
      params.push(`mineOnly=${encodeURIComponent(mineOnly)}`)
    }

    return axios.get(
      `${API_ENDPOINT}api/SwiftAppAI/GetSwiftClosingNext7Days?${params.join("&")}`,
      { headers: { Authorization: "Bearer " + token } }
    )
  },
  GetSwiftClearedConditionsSummary(token, startDate = null, endDate = null) {
    return axios.get(
      `${SWIFT_API_ENDPOINT}api/Conditions/GetSwiftClearedConditionsSummary`,
      {
        headers: { Authorization: "Bearer " + token },
        params: {
          startDate,
          endDate
        }
      }
    )
  },

  GetSwiftClearedConditionsDrillIn(title, token) {
    return axios.get(
      `${SWIFT_API_ENDPOINT}api/Conditions/GetSwiftClearedConditionsDrillIn?title=${encodeURIComponent(title)}`,
      { headers: { Authorization: "Bearer " + token } }
    )
  },

  GetUwAvgSubmittalCounterRolling90Days(token) {
    return axios.get(
      `${SWIFT_API_ENDPOINT}api/Conditions/GetUwAvgSubmittalCounterRolling90Days`,
      { headers: { Authorization: "Bearer " + token } }
    )
  },

  GetUwSubmittalCounterDrillInRolling90Days(f1411, token) {
    return axios.get(
      `${SWIFT_API_ENDPOINT}api/Conditions/GetUwSubmittalCounterDrillInRolling90Days?f1411=${encodeURIComponent(f1411)}`,
      { headers: { Authorization: "Bearer " + token } }
    )
  },

  GetLoansWithOpenConditionsAfterCondApprovalRolling90Days(token) {
    return axios.get(
      `${SWIFT_API_ENDPOINT}api/Conditions/GetLoansWithOpenConditionsAfterCondApprovalRolling90Days`,
      { headers: { Authorization: "Bearer " + token } }
    )
  },

  GetOpenConditionsAfterCondApprovalDrillIn(loanId, token) {
    return axios.get(
      `${SWIFT_API_ENDPOINT}api/Conditions/GetOpenConditionsAfterCondApprovalDrillIn?loanId=${encodeURIComponent(loanId)}`,
      { headers: { Authorization: "Bearer " + token } }
    )
  },

  GetCtcWizardSummary(token, startDate = null, endDate = null) {
    return axios.get(
      `${SWIFT_API_ENDPOINT}api/Conditions/GetCtcWizardSummary`,
      {
        headers: { Authorization: "Bearer " + token },
        params: { startDate, endDate }
      }
    )
  },

  GetCtcWizardDrillIn(loanId, token) {
    return axios.get(
      `${SWIFT_API_ENDPOINT}api/Conditions/GetCtcWizardDrillIn?loanId=${encodeURIComponent(loanId)}`,
      { headers: { Authorization: "Bearer " + token } }
    )
  },
  GetResubmittalsOverBizHours(token, azureId) {
    return axios.get(
      `${SWIFT_API_ENDPOINT}api/Conditions/GetResubmittalsOverBizHours`,
      {
        headers: { Authorization: "Bearer " + token },
        params: { azureId }
      }
    )
  },
  GetSwiftNotClearedConditionsSummary(token, startDate = null, endDate = null) {
    return axios.get(
      `${SWIFT_API_ENDPOINT}api/Conditions/GetSwiftNotClearedConditionsSummary`,
      {
        headers: { Authorization: "Bearer " + token },
        params: {
          startDate,
          endDate
        }
      }
    )
  },

  GetSwiftNotClearedConditionsDrillIn(title, token) {
    return axios.get(
      `${SWIFT_API_ENDPOINT}api/Conditions/GetSwiftNotClearedConditionsDrillIn?title=${encodeURIComponent(title)}`,
      { headers: { Authorization: "Bearer " + token } }
    )
  },
  GetUnderwritesResubs(token, azureId) {
    return axios.get(
      `${SWIFT_API_ENDPOINT}api/Conditions/GetUnderwritesResubs?azureId=${azureId}`,
      { headers: { Authorization: "Bearer " + token } }
    )
  },

  GetRepricedLocksNeedingReview(days = 90, token) {
    return axios.get(
      `${API_ENDPOINT}api/SwiftAppAI/GetRepricedLocksNeedingReview?days=${days}`,
      { headers: { Authorization: "Bearer " + token } }
    )
  },

  async GetLockNotes(loanId, token) {
    return axios.get(
      `${API_ENDPOINT}api/LoanNotes/GetLockNotes?loanId=${encodeURIComponent(loanId)}`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    )
  },

  async SubmitNote(loanNote, token) {
    return axios.post(
      `${API_ENDPOINT}api/LoanNotes/SubmitNote`,
      loanNote,
      {
        headers: {
          "Authorization": "Bearer " + token,
          "Content-Type": "application/json"
        }
      }
    )
  },
  async GetLockLoanExclusions(token) {
    return axios.get(
      `${API_ENDPOINT}api/SwiftAppAI/GetLockLoanExclusions`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    )
  },

  async UpsertLockLoanExclusion(request, token) {
    return axios.post(
      `${API_ENDPOINT}api/SwiftAppAI/UpsertLockLoanExclusion`,
      request,
      {
        headers: {
          "Authorization": "Bearer " + token,
          "Content-Type": "application/json"
        }
      }
    )
  },

  async DeleteLockLoanExclusion(loanId, token) {
    return axios.post(
      `${API_ENDPOINT}api/SwiftAppAI/DeleteLockLoanExclusion?loan_id=${encodeURIComponent(loanId)}`,
      {},
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    )
  },

  async GetLockAltOrgs(token) {
    return axios.get(
      `${API_ENDPOINT}api/SwiftAppAI/GetLockAltOrgs`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    )
  },

  async UpsertLockAltOrg(request, token) {
    return axios.post(
      `${API_ENDPOINT}api/SwiftAppAI/UpsertLockAltOrg`,
      request,
      {
        headers: {
          "Authorization": "Bearer " + token,
          "Content-Type": "application/json"
        }
      }
    )
  },

  async DeleteLockAltOrg(id, token) {
    return axios.post(
      `${API_ENDPOINT}api/SwiftAppAI/DeleteLockAltOrg?id=${encodeURIComponent(id)}`,
      {},
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    )
  },

  async UpdateRepricedLockManualStatus(request, token) {
    return axios.post(
      `${API_ENDPOINT}api/SwiftAppAI/UpdateRepricedLockManualStatus`,
      request,
      {
        headers: {
          "Authorization": "Bearer " + token,
          "Content-Type": "application/json"
        }
      }
    )
  },

  async GetLockManualStatuses(token) {
    return axios.get(
      `${API_ENDPOINT}api/SwiftAppAI/GetLockManualStatuses`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    )
  },
  async GetLoanPipelineAnalysisByLoanId(loanId, token) {
    return axios.get(
      `${API_ENDPOINT}api/SwiftAppAI/GetAnalysisByLoanId?loan_id=${encodeURIComponent(loanId)}`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    )
  },
  // Fetch pending approval row by GUID — called on mount of RepriceApproval.vue.
  // The token comes from the ?token= query param embedded in the email link.
  async GetRepricePendingApprovalById(pendingId, token) {
    return axios.get(
      `${API_ENDPOINT}api/SwiftAppAI/GetRepricePendingApprovalById?id=${encodeURIComponent(pendingId)}`,
      {
        headers: { "Authorization": "Bearer " + token }
      }
    )
  },

  // Submit LO approval — called when the LO clicks the Approve button.
  // Sends the MSAL-authenticated user's azureId + email for the audit log.
  async ApproveRepricePending(pendingId, azureId, email, token) {
    return axios.post(
      `${API_ENDPOINT}api/SwiftAppAI/ApproveRepricePending?id=${encodeURIComponent(pendingId)}`,
      { azureId, email },
      {
        headers: {
          "Authorization": "Bearer " + token,
          "Content-Type": "application/json"
        }
      }
    )
  },
  GetHmdaProcessingLog(days = 90, token) {
    return axios.get(
      `${API_ENDPOINT}api/SwiftAppAI/GetHmdaProcessingLog?days=${days}`,
      { headers: { Authorization: "Bearer " + token } }
    )
  },

  GetAiInsuringLog(days = 90, token) {
    return axios.get(
      `${API_ENDPOINT}api/SwiftAppAI/GetAiInsuringLog?days=${days}`,
      { headers: { Authorization: "Bearer " + token } }
    )
  },

  GetFhaMipPaymentQueue(days = 90, token) {
    return axios.get(
      `${API_ENDPOINT}api/SwiftAppAI/GetFhaMipPaymentQueue?days=${days}`,
      { headers: { Authorization: "Bearer " + token } }
    )
  },

  // Extension calls
  async GetLockExtensionsNeedingReview(days = 90, token) {
    return axios.get(
      `${API_ENDPOINT}api/SwiftAppAI/GetLockExtensionsNeedingReview?days=${days}`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    )
  },

  // Aggregate market-based/at-cost and auto-approved/manual splits for the queue insights panel.
  // Returns counts only, not rows — safe to call on every modal open.
  async GetLockExtensionTypeStats(days = 90, token) {
    return axios.get(
      `${API_ENDPOINT}api/SwiftAppAI/GetLockExtensionTypeStats?days=${days}`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    )
  },

  async GetLockExtensionNotes(loanId, token) {
    return axios.get(
      `${API_ENDPOINT}api/LoanNotes/GetLockNotes?loanId=${encodeURIComponent(loanId)}`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    )
  },

  async SubmitLockExtensionNote(request, token) {
    return axios.post(
      `${API_ENDPOINT}api/LoanNotes/SubmitNote`,
      request,
      {
        headers: {
          "Authorization": "Bearer " + token,
          "Content-Type": "application/json"
        }
      }
    )
  },

  async GetLockExtensionExclusions(token) {
    return axios.get(
      `${API_ENDPOINT}api/SwiftAppAI/GetLockExtensionExclusions`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    )
  },

  async UpsertLockExtensionExclusion(request, token) {
    return axios.post(
      `${API_ENDPOINT}api/SwiftAppAI/UpsertLockExtensionExclusion`,
      request,
      {
        headers: {
          "Authorization": "Bearer " + token,
          "Content-Type": "application/json"
        }
      }
    )
  },

  async DeleteLockExtensionExclusion(loanId, token) {
    return axios.post(
      `${API_ENDPOINT}api/SwiftAppAI/DeleteLockExtensionExclusion?loan_id=${encodeURIComponent(loanId)}`,
      {},
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    )
  },

  async GetLockExtensionAltOrgs(token) {
    return axios.get(
      `${API_ENDPOINT}api/SwiftAppAI/GetLockExtensionAltOrgs`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    )
  },

  async UpsertLockExtensionAltOrg(request, token) {
    return axios.post(
      `${API_ENDPOINT}api/SwiftAppAI/UpsertLockExtensionAltOrg`,
      request,
      {
        headers: {
          "Authorization": "Bearer " + token,
          "Content-Type": "application/json"
        }
      }
    )
  },

  async DeleteLockExtensionAltOrg(id, token) {
    return axios.post(
      `${API_ENDPOINT}api/SwiftAppAI/DeleteLockExtensionAltOrg?id=${encodeURIComponent(id)}`,
      {},
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    )
  },

  async GetLockExtensionManualStatuses(token) {
    return axios.get(
      `${API_ENDPOINT}api/SwiftAppAI/GetLockExtensionManualStatuses`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    )
  },

  async UpdateLockExtensionManualStatus(request, token) {
    return axios.post(
      `${API_ENDPOINT}api/SwiftAppAI/UpdateLockExtensionManualStatus`,
      request,
      {
        headers: {
          "Authorization": "Bearer " + token,
          "Content-Type": "application/json"
        }
      }
    )
  },

  async GetLockExtensionAnalysisByLoanId(loanId, token) {
    return axios.get(
      `${API_ENDPOINT}api/SwiftAppAI/GetLockExtensionAnalysisByLoanId?loan_id=${encodeURIComponent(loanId)}`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    )
  },

  async GetLockExtensionPendingApprovalById(id, token) {
    return axios.get(
      `${API_ENDPOINT}api/SwiftAppAI/GetLockExtensionPendingApprovalById?id=${encodeURIComponent(id)}`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    )
  },

  async ApproveLockExtensionPending(id, azureId, email, token) {
    return axios.post(
      `${API_ENDPOINT}api/SwiftAppAI/ApproveLockExtensionPending?id=${encodeURIComponent(id)}`,
      { azureId, email },
      {
        headers: {
          "Authorization": "Bearer " + token,
          "Content-Type": "application/json"
        }
      }
    )
  },

  async GetLockExtensionLandingData(loanId, token) {
    return axios.get(
      `${API_ENDPOINT}api/SwiftAppAI/GetLockExtensionLandingData?loan_id=${encodeURIComponent(loanId)}`,
      { headers: authHeaders(token) }
    )
  },

  async RunSingleLockExtension(request, token) {
    return axios.post(
      `${API_ENDPOINT}api/SwiftAppAI/RunSingleLockExtension`,
      request,
      {
        headers: { ...authHeaders(token), "Content-Type": "application/json" }
      }
    )
  },

  // Commits a manual-review request to the Lock Desk. Separate from RunSingleLockExtension so the
  // loan officer can price as many dates as they like without leaving a ticket behind for each one.
  async SendLockExtensionToLockDesk(request, token) {
    return axios.post(
      `${API_ENDPOINT}api/SwiftAppAI/SendLockExtensionToLockDesk`,
      request,
      {
        headers: { ...authHeaders(token), "Content-Type": "application/json" }
      }
    )
  },

  async SubmitApprovedLockExtension(request, token) {
    return axios.post(
      `${API_ENDPOINT}api/SwiftAppAI/SubmitApprovedLockExtension`,
      request,
      {
        headers: { ...authHeaders(token), "Content-Type": "application/json" }
      }
    )
  },

  async RejectLockExtensionRecommendation(request, token) {
    return axios.post(
      `${API_ENDPOINT}api/SwiftAppAI/RejectLockExtensionRecommendation`,
      request,
      {
        headers: {
          "Authorization": "Bearer " + token,
          "Content-Type": "application/json"
        }
      }
    )
  },
  GetLockExtensionEligibility(loanId, daysToExtend, token) {
    return axios.get(
      `${API_ENDPOINT}api/SwiftAppAI/GetLockExtensionEligibility`,
      {
        params: {
          loanId,
          daysToExtend
        },
        headers: authHeaders(token),
        timeout: 300000 // 5 minutes
      }
    )
  },
  // Server-authoritative Lock Desk request window. The browser clock is user-settable,
  // so the landing page renders this rather than deciding from the local clock.
  GetLockExtensionRequestWindow(token) {
    return axios.get(
      `${API_ENDPOINT}api/SwiftAppAI/GetLockExtensionRequestWindow`,
      { headers: authHeaders(token) }
    )
  },
  // Creates the Best Effort lock extension ticket, or repoints the loan's open one at the newly
  // requested date. Dedup and update are server-side so this page never pulls the lock desk queue —
  // it is reachable anonymously from the emailed link, and that listing carries every loan on the desk.
  UpsertLockExtensionQueueItem(request, token) {
    return axios.post(
      `${API_ENDPOINT}api/SwiftAppAI/UpsertLockExtensionQueueItem`,
      request,
      {
        headers: { ...authHeaders(token), "Content-Type": "application/json" },
        timeout: 60000
      }
    )
  },
  GetLoanFileLockStatus(loanId, token) {
    return axios.get(
      `${API_ENDPOINT}api/SwiftAppAI/GetLoanFileLockStatus`,
      {
        params: {
          loanId
        },
        headers: authHeaders(token),
        timeout: 60000
      }
    )
  },
  GetLockExtensionProcessingStatus(loanId, token) {
    return axios.get(
      `${API_ENDPOINT}api/SwiftAppAI/GetLockExtensionProcessingStatus`,
      {
        params: {
          loanId
        },
        headers: authHeaders(token),
        timeout: 30000
      }
    )
  },
  async GetLockManualStatuses(token) {
    return axios.get(
      `${API_ENDPOINT}api/SwiftAppAI/GetLockManualStatuses`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    )
  },
  async GetLoanPipelineAnalysisByLoanId(loanId, token) {
    return axios.get(
      `${API_ENDPOINT}api/SwiftAppAI/GetAnalysisByLoanId?loan_id=${encodeURIComponent(loanId)}`,
      {
        headers: {
          "Authorization": "Bearer " + token
        }
      }
    )
  },
  // Fetch pending approval row by GUID — called on mount of RepriceApproval.vue.
  // The token comes from the ?token= query param embedded in the email link.
  async GetRepricePendingApprovalById(pendingId, token) {
    return axios.get(
      `${API_ENDPOINT}api/SwiftAppAI/GetRepricePendingApprovalById?id=${encodeURIComponent(pendingId)}`,
      {
        headers: { "Authorization": "Bearer " + token }
      }
    )
  },

  // Submit LO approval — called when the LO clicks the Approve button.
  // Sends the MSAL-authenticated user's azureId + email for the audit log.
  async ApproveRepricePending(pendingId, azureId, email, token) {
    return axios.post(
      `${API_ENDPOINT}api/SwiftAppAI/ApproveRepricePending?id=${encodeURIComponent(pendingId)}`,
      { azureId, email },
      {
        headers: {
          "Authorization": "Bearer " + token,
          "Content-Type": "application/json"
        }
      }
    )
  },
  GetHmdaProcessingLog(days = 90, token) {
    return axios.get(
      `${API_ENDPOINT}api/SwiftAppAI/GetHmdaProcessingLog?days=${days}`,
      { headers: { Authorization: "Bearer " + token } }
    )
  },
  // ── ADD TO: swift_spa/src/api/api.service.js ────────────────────────────────
  // Paste these methods into the existing exported object, alongside
  // GetHmdaProcessingLog, GetLockExtensionsNeedingReview, etc.
  // They follow the exact same axios pattern already in the file.

  CreateReverseMortgageRequest(dto, token) {
    return axios.post(
      `${API_ENDPOINT}api/SwiftAppAI/CreateReverseMortgageRequest`,
      dto,
      { headers: { Authorization: 'Bearer ' + token } }
    )
  },

  GetReverseMortgageRequests(token, id) {
    return axios.get(
      `${API_ENDPOINT}api/SwiftAppAI/GetReverseMortgageRequests?azureId=${id}`,
      { headers: { Authorization: 'Bearer ' + token } }
    )
  },

  GetReverseMortgageRequestById(id, token) {
    return axios.get(
      `${API_ENDPOINT}api/SwiftAppAI/GetReverseMortgageRequestById?id=${id}`,
      { headers: { Authorization: 'Bearer ' + token } }
    )
  },

  UpdateReverseMortgageRequest(id, dto, token) {
    return axios.post(
      `${API_ENDPOINT}api/SwiftAppAI/UpdateReverseMortgageRequest?id=${id}`,
      dto,
      { headers: { Authorization: 'Bearer ' + token } }
    )
  },

  DeleteReverseMortgageRequest(id, token) {
    return axios.post(
      `${API_ENDPOINT}api/SwiftAppAI/DeleteReverseMortgageRequest?id=${id}`,
      null,
      { headers: { Authorization: 'Bearer ' + token } }
    )
  },
  CreateCommercialLoanRequest(dto, token) {
    return axios.post(
      `${API_ENDPOINT}api/SwiftAppAI/CreateCommercialLoanRequest`,
      dto,
      { headers: { Authorization: 'Bearer ' + token } }
    )
  },

  GetCommercialLoanRequests(token, id) {
    return axios.get(
      `${API_ENDPOINT}api/SwiftAppAI/GetCommercialLoanRequests?azureId=${id}`,
      { headers: { Authorization: 'Bearer ' + token } }
    )
  },

  GetCommercialLoanRequestById(id, token) {
    return axios.get(
      `${API_ENDPOINT}api/SwiftAppAI/GetCommercialLoanRequestById?id=${id}`,
      { headers: { Authorization: 'Bearer ' + token } }
    )
  },

  UpdateCommercialLoanRequest(id, dto, token) {
    return axios.post(
      `${API_ENDPOINT}api/SwiftAppAI/UpdateCommercialLoanRequest?id=${id}`,
      dto,
      { headers: { Authorization: 'Bearer ' + token } }
    )
  },

  DeleteCommercialLoanRequest(id, token) {
    return axios.post(
      `${API_ENDPOINT}api/SwiftAppAI/DeleteCommercialLoanRequest?id=${id}`,
      null,
      { headers: { Authorization: 'Bearer ' + token } }
    )
  },

  async SubmitLoanPriceSheetSelection(request, token) {
    return axios.post(
      `${API_ENDPOINT}api/SwiftAppAI/SubmitLoanPriceSheetSelection`,
      request,
      {
        headers: {
          "Authorization": "Bearer " + token,
          "Content-Type": "application/json"
        },
        timeout: 300000
      }
    )
  },
  SendLockExtensionManualProcessingEmail(request, token) {
    return axios.post(
      `${API_ENDPOINT}api/SwiftAppAI/ManualProcessingEmail`,
      request,
      {
        headers: {
          "Authorization": "Bearer " + token,
          "Content-Type": "application/json"
        },
        timeout: 300000
      }
    )
  },

  // ── Lock Desk Queue ──────────────────────────────────────────────────────────
  async GetLockDeskQueueItems(days = 90, token) {
    return axios.get(
      `${API_ENDPOINT}api/SwiftAppAI/GetLockDeskQueueItems?days=${days}`,
      { headers: { Authorization: "Bearer " + token } }
    )
  },
  async GetLockDeskQueueNotes(itemId, token) {
    return axios.get(
      `${API_ENDPOINT}api/SwiftAppAI/GetLockDeskQueueNotes?itemId=${encodeURIComponent(itemId)}`,
      { headers: { Authorization: "Bearer " + token } }
    )
  },
  async GetLockDeskQueueAssignments(itemId, token) {
    return axios.get(
      `${API_ENDPOINT}api/SwiftAppAI/GetLockDeskQueueAssignments?itemId=${encodeURIComponent(itemId)}`,
      { headers: { Authorization: "Bearer " + token } }
    )
  },
  async SubmitLockDeskQueueNote(request, token) {
    return axios.post(
      `${API_ENDPOINT}api/SwiftAppAI/SubmitLockDeskQueueNote`,
      request,
      { headers: { Authorization: "Bearer " + token } }
    )
  },
  async SendLockDeskQueueNote(request, token) {
    return axios.post(
      `${API_ENDPOINT}api/SwiftAppAI/SendLockDeskQueueNote`,
      request,
      { headers: { Authorization: "Bearer " + token } }
    )
  },
  async DeleteLockDeskQueueNote(request, token) {
    return axios.post(
      `${API_ENDPOINT}api/SwiftAppAI/DeleteLockDeskQueueNote`,
      request,
      { headers: { Authorization: "Bearer " + token } }
    )
  },
  async UpdateLockDeskQueueItemStatus(request, token) {
    return axios.post(
      `${API_ENDPOINT}api/SwiftAppAI/UpdateLockDeskQueueItemStatus`,
      request,
      { headers: { Authorization: "Bearer " + token } }
    )
  },
  async AssignLockDeskQueueItem(request, token) {
    return axios.post(
      `${API_ENDPOINT}api/SwiftAppAI/AssignLockDeskQueueItem`,
      request,
      { headers: { Authorization: "Bearer " + token } }
    )
  },
  async CreateLockDeskQueueItem(request, token) {
    return axios.post(
      `${API_ENDPOINT}api/SwiftAppAI/CreateLockDeskQueueItem`,
      request,
      { headers: { Authorization: "Bearer " + token } }
    )
  },
  async GetLockDeskAssignableUsers(token) {
    return axios.get(
      `${API_ENDPOINT}api/SwiftAppAI/GetLockDeskAssignableUsers`,
      { headers: { Authorization: "Bearer " + token } }
    )
  },
  async UpsertLockDeskAssignableUser(request, token) {
    return axios.post(
      `${API_ENDPOINT}api/SwiftAppAI/UpsertLockDeskAssignableUser`,
      request,
      { headers: { Authorization: "Bearer " + token } }
    )
  },
  async IntakeLockDeskQueueItem(request, token) {
    return axios.post(
      `${API_ENDPOINT}api/SwiftAppAI/IntakeLockDeskQueueItem`,
      request,
      { headers: { Authorization: "Bearer " + token } }
    )
  },
  async GenerateLockDeskQueueItem(request, token) {
    return axios.post(
      `${API_ENDPOINT}api/SwiftAppAI/GenerateLockDeskQueueItem`,
      request,
      { headers: { Authorization: "Bearer " + token } }
    )
  },
  GetInitialDisclosureLog(days = 90, token) {
    return axios.get(`${API_ENDPOINT}api/SwiftAppAI/GetInitialDisclosureLog`, {
      params: { days },
      headers: { Authorization: `Bearer ${token}` }
    })
  },

  GetInitialDisclosureQueueStatus(token) {
    return axios.get(`${API_ENDPOINT}api/SwiftAppAI/GetInitialDisclosureQueueStatus`, {
      headers: { Authorization: `Bearer ${token}` }
    })
  },

  // ── FHA MIP Insuring ─────────────────────────────────────────────────────────
  // Sends one or more receipt PDFs to the backend, which forwards each to
  // OllamaBridge's drop folder for the FHA MIP tool to process.
  async UploadFhaMipReceipts(files, token) {
    const formData = new FormData()
    for (const file of files) {
      formData.append('files', file, file.name)
    }

    return axios.post(
      `${API_ENDPOINT}api/SwiftAppAI/UploadFhaMipReceipts`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        },
        timeout: 300000 // 5 minutes — several large PDFs at once
      }
    )
  },

  // ── Monthly FHA MIP (periodic premiums) ─────────────────────────────────────
  // Same pattern as UploadFhaMipReceipts, but targets the MONTHLY drop folder.
  // Files are the FHAC "FHA Excel Export" (.xls / .xlsx) plus optional receipt
  // PDFs; the backend forwards each to OllamaBridge's C:/fhamonthlymip folder
  // for the monthly MIP sweep to process.
  async UploadFhaMonthlyMipFiles(files, token) {
    const formData = new FormData()
    for (const file of files) {
      formData.append('files', file, file.name)
    }

    return axios.post(
      `${API_ENDPOINT}api/SwiftAppAI/UploadFhaMonthlyMipFiles`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        },
        timeout: 300000 // 5 minutes
      }
    )
  },

  async GsaiPrompt(prompt) {
    return axios.post(
      `${GSAI_ENDPOINT}api/OpenAI/prompt`,
      JSON.stringify(prompt),
      {
        headers: {
          'Content-Type': 'application/json',
          'API-Key': process.env.VUE_APP_GSAI_API_KEY || ''
        }
      }
    )
  },
  async UploadFhaMonthlyMipReceiptsToLoans(excelFile, pdfFile, token, dryRun = false) {
  const formData = new FormData()
  formData.append('xlsx', excelFile, excelFile.name)
  if (pdfFile) formData.append('pdf', pdfFile, pdfFile.name)
 
  return axios.post(
    `${API_ENDPOINT}api/SwiftAppAI/UploadFhaMonthlyMipReceiptsToLoans?dryRun=${dryRun}`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      },
      timeout: 600000 // 10 minutes — uploads to every loan in the batch
    }
  )
},

// ── Concessions: approver roster ────────────────────────────────────────────
// The roster is maintained in the "Polly User Access Level" workbook and pushed
// in by a lock desk manager. One row per Polly user: their division, who
// approves for them, and their auto-approve ceilings.
async GetConcessionApprovers(activeOnly, token) {
  return axios.get(
    `${API_ENDPOINT}api/SwiftAppAI/GetConcessionApprovers?activeOnly=${activeOnly ? 'true' : 'false'}`,
    { headers: authHeaders(token) }
  )
},

// Uploads the workbook. `commit` false parses and returns the diff without
// writing anything; true applies it.
//
// The file is sent twice — once to preview, once to commit — rather than the
// server holding parsed state between the two calls. Callers must keep the same
// File object for both, or the manager would confirm one file and apply another.
async ImportConcessionApprovers(file, commit, token) {
  const formData = new FormData()
  formData.append('file', file, file.name)
  formData.append('commit', commit ? 'true' : 'false')

  return axios.post(
    `${API_ENDPOINT}api/SwiftAppAI/ImportConcessionApprovers`,
    formData,
    {
      headers: {
        ...authHeaders(token),
        'Content-Type': 'multipart/form-data'
      },
      timeout: 300000 // 5 minutes — 400+ rows, parsed twice per import
    }
  )
},

async GetConcessionApproverImports(take, token) {
  return axios.get(
    `${API_ENDPOINT}api/SwiftAppAI/GetConcessionApproverImports?take=${take || 25}`,
    { headers: authHeaders(token) }
  )
},

// ── Concessions: reason dropdown ────────────────────────────────────────────
// Polly owns the reason list (its "price exception reasons"). We mirror it into
// concession_reasons so the form still renders when Polly is unreachable.
// Pass a tier to get the reasons offered for it; reasons with no tier scope come
// back for both.
async GetConcessionReasons(tier, token) {
  const tierParam = tier ? `&tier=${encodeURIComponent(tier)}` : ''
  return axios.get(
    `${API_ENDPOINT}api/SwiftAppAI/GetConcessionReasons?activeOnly=true${tierParam}`,
    { headers: authHeaders(token) }
  )
},

// Refreshes the mirror from Polly. Reasons Polly no longer returns are
// deactivated, not deleted, so historical requests keep resolving.
async SyncConcessionReasonsFromPolly(token) {
  return axios.post(
    `${API_ENDPOINT}api/SwiftAppAI/SyncConcessionReasonsFromPolly`,
    {},
    { headers: authHeaders(token), timeout: 60000 }
  )
},

// ── Concessions: requests ───────────────────────────────────────────────────
// Everything the request form needs in one call: whether this user may request,
// their division/branch, whether they're an approver, and the reason lists per
// tier. The server reads the user from the token, so nothing is passed here.
async GetConcessionUserContext(token) {
  return axios.get(
    `${API_ENDPOINT}api/SwiftAppAI/GetConcessionUserContext`,
    { headers: authHeaders(token) }
  )
},

// Dry run. Same validation and decision engine as submit, but records nothing
// and calls Polly with isPreview=true, so no price exception is created. Returns
// the would-be decision plus Polly's before/after pricing.
async PreviewConcessionRequest(request, token) {
  return axios.post(
    `${API_ENDPOINT}api/SwiftAppAI/PreviewConcessionRequest`,
    request,
    { headers: authHeaders(token), timeout: 120000 } // calls Polly inline
  )
},

// Files a concession. The server runs the decision engine, so the response says
// whether it auto-approved or who it went to — the client never decides.
async SubmitConcessionRequest(request, token) {
  return axios.post(
    `${API_ENDPOINT}api/SwiftAppAI/SubmitConcessionRequest`,
    request,
    { headers: authHeaders(token), timeout: 120000 } // may call Polly inline
  )
},

async DecideConcessionRequest(request, token) {
  return axios.post(
    `${API_ENDPOINT}api/SwiftAppAI/DecideConcessionRequest`,
    request,
    { headers: authHeaders(token), timeout: 120000 } // may call Polly inline
  )
},

// Dashboard feed. Scoped server-side by who you are — approvers see their
// divisions, lock desk sees everything, everyone else sees only their own.
async GetConcessionRequests(days, status, division, token) {
  const params = new URLSearchParams()
  params.set('days', days || 90)
  if (status) params.set('status', status)
  if (division) params.set('division', division)

  return axios.get(
    `${API_ENDPOINT}api/SwiftAppAI/GetConcessionRequests?${params.toString()}`,
    { headers: authHeaders(token) }
  )
},

// The cross-request audit feed: every action and who took it. POST because the
// filter set is a body. Scoped server-side by who you are.
async GetConcessionAuditTrail(query, token) {
  return axios.post(
    `${API_ENDPOINT}api/SwiftAppAI/GetConcessionAuditTrail`,
    query || {},
    { headers: authHeaders(token) }
  )
},

// The raw Polly calls for one concession — what we sent and what came back.
async GetConcessionPollyApiLog(requestId, token) {
  return axios.get(
    `${API_ENDPOINT}api/SwiftAppAI/GetConcessionPollyApiLog?requestId=${encodeURIComponent(requestId)}`,
    { headers: authHeaders(token) }
  )
},

async GetConcessionRequestEvents(requestId, token) {
  return axios.get(
    `${API_ENDPOINT}api/SwiftAppAI/GetConcessionRequestEvents?requestId=${encodeURIComponent(requestId)}`,
    { headers: authHeaders(token) }
  )
},
};
